import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { Grid2 as Grid } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { LabReportHeader } from "./components/LabReportHeader";
import { MechanicalTestTable } from "./components/MechanicalTestTable";
import { ElementTable } from "./components/tables/elements-table/ElementTable";
import { useMechanicalTestData } from "./hooks/useMechanicalTestData";

export const LabReport = () => {
	const {
		state: {
			heatLabData,
			heat,
			mechanicalTests,
			mechanicalSamples,
			mechanicalGradeLimits,
			mechanicalResultSources,
			isMechanicalDataLoading,
		},
	} = useHeatReportContext();
	const gridRef = useRef<AgGridReact<any>>(null);
	const { loadMechanicalTestData } = useMechanicalTestData();
	const [coloringEnabled, setColoringEnabled] = useState(true);

	// Load mechanical test data when heat changes
	useEffect(() => {
		if (heat?.HeatId) {
			loadMechanicalTestData(heat.HeatId);
		}
	}, [heat?.HeatId]);

	const handleExport = () => {
		gridRef.current?.api.exportDataAsExcel({
			fileName: `LabReport_${heatLabData?.HeatName ?? "data"}.xlsx`,
			sheetName: "Lab Report of " + heatLabData?.HeatName,
		});
	};

	return (
		<Grid container spacing={1}>
			<Grid size={{ xs: 12 }}>
				<LabReportHeader onExport={handleExport} />
			</Grid>

			<Grid size={{ xs: 12 }}>
				<ElementTable
					gridRef={gridRef}
					key={heatLabData?.HeatId}
					coloringEnabled={coloringEnabled}
					onToggleColoring={setColoringEnabled}
				/>
			</Grid>

			<Grid size={{ xs: 12 }}>
				<MechanicalTestTable
					loadingGrid={isMechanicalDataLoading}
					heat={heat}
					key={heat?.HeatId}
					mechanicalSamples={mechanicalSamples}
					mechanicalTests={mechanicalTests}
					mechanicalGradeLimits={mechanicalGradeLimits}
					mechanicalResultSources={mechanicalResultSources}
				/>
			</Grid>
		</Grid>
	);
};
